import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgSelectModule } from '@ng-select/ng-select';
import { RxAutocompleteComponent } from './rx-autocomplete.component';
import { RxAutocompleteOptionDirective } from './rx-autocomplete-option';
import { RxAutocompleteLabelDirective } from './rx-autocomplete-label';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    RxAutocompleteComponent,
    RxAutocompleteOptionDirective,
    RxAutocompleteLabelDirective,
  ],
  exports: [RxAutocompleteComponent, RxAutocompleteOptionDirective, RxAutocompleteLabelDirective],
})
export class RxAutocompleteModule {}
